import axios from 'axios';

let URLSearchParams = require('url-search-params');

import Registry from 'registry';

import {getLangPrefix} from 'l10n';
import {requestInterceptor} from "./interceptors";

// todo: lang URL prefix for localized backend requests

export function getAxios(params = {}) {
    const defaultParams = {urlPrefix: true, forcedSSL: false, uploadURL: false};

    let {urlPrefix, forcedSSL, uploadURL} = Object.assign({}, defaultParams, params);

    let BACKEND_URL = Registry.get('BACKEND_URL'),
        BACKEND_URL_PREFIX = Registry.get('BACKEND_URL_PREFIX'),
        UPLOAD_URL = Registry.get('UPLOAD_URL'),
        BACKEND_AUTH_USER = Registry.get('BACKEND_AUTH_USER'),
        BACKEND_AUTH_PASSWORD = Registry.get('BACKEND_AUTH_PASSWORD');

    if (forcedSSL) {
        BACKEND_URL = BACKEND_URL.replace(/^http:\/\//, 'https://');
    }

    let baseURL = uploadURL ? UPLOAD_URL : BACKEND_URL;


    let langPrefix = getLangPrefix();

    if(langPrefix) baseURL += langPrefix;
    if(urlPrefix) baseURL += BACKEND_URL_PREFIX;

    let axiosConfig = {
        baseURL: baseURL,
        withCredentials: true
    };

    if (BACKEND_AUTH_USER && BACKEND_AUTH_PASSWORD) {
        axiosConfig.auth = {
            username: BACKEND_AUTH_USER,
            password: BACKEND_AUTH_PASSWORD};
    }

    let axiosInstance = axios.create(axiosConfig);
    axiosInstance.interceptors.request.use(requestInterceptor);
    
    return axiosInstance;
}

export function formDataToRequestParams(formData) {
    let requestParams = new URLSearchParams();

    for (let name in formData) {
        requestParams.append(name, formData[name]);
    }

    return requestParams.toString();
}


// WEBPACK FOOTER //
// ./src/backend-helpers/axios.js